import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveBettingRules } from "@/api/bettingRules";
import { BettingRulesQueryKeys } from "@/tanstackQuery/queries/bettingRules";

export const useSaveBettingRules = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveBettingRules,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [BettingRulesQueryKeys.BettingRules],
      });
    },
  });
};
